module.exports = __webpack_public_path__ + "990c6f160ea8aaabd4b65289acc2ac6c.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/voguescandinavia.svg
// module id = 224
// module chunks = 0